export type CustomFilterInputType = 'input' | 'dropdown' | 'checkbox' | 'date' | 'multiSelect';

export interface EmissionsFilterConfigItem {
  name: string;
  model: string | null;
  inputType: CustomFilterInputType;
}

export const emissionsFilterConfig: EmissionsFilterConfigItem[] = [
  { name: 'Category', model: 'category', inputType: 'multiSelect' },
  { name: 'Emission Type', model: 'emissionType', inputType: 'multiSelect' },
  { name: 'Country', model: 'country', inputType: 'multiSelect' },
  { name: 'Location', model: 'location', inputType: 'multiSelect' },
  { name: 'Vehicle', model: 'vehicle', inputType: 'multiSelect' },
  { name: 'Project', model: 'project', inputType: 'multiSelect' },
  { name: 'Supplier', model: 'contactSupplier', inputType: 'multiSelect' },
  { name: 'Manufacturer', model: 'manufacturer', inputType: 'multiSelect' },
  { name: 'Scope', model: 'scope', inputType: 'multiSelect' },
  { name: 'Measurement Unit', model: 'measurementUnit', inputType: 'multiSelect' },
  { name: 'Group', model: 'group', inputType: 'multiSelect' },
  { name: 'Subsidiary', model: 'subsidiary', inputType: 'multiSelect' },
  { name: 'Data Type', model: 'dataType', inputType: 'multiSelect' },
  { name: 'Source', model: 'source', inputType: 'multiSelect' },
  { name: 'FLAG', model: 'isFlag', inputType: 'dropdown' },
  { name: 'FLAG Category', model: 'flagCategory', inputType: 'multiSelect' },
  { name: 'Emission Factor', model: 'emissionFactor', inputType: 'input' },
  { name: 'Custom Field', model: 'customField', inputType: 'input' }
];

/** FLAG filters are only meaningful for organisations with FLAG enabled. */
export const FLAG_FILTER_MODELS = ['isFlag', 'flagCategory'];

export const filterSpendBasedConfig: EmissionsFilterConfigItem[] = [
  { name: 'Activity', model: 'activity', inputType: 'input' },
  { name: 'Group', model: 'group', inputType: 'multiSelect' },
  { name: 'Scope', model: 'scope', inputType: 'multiSelect' },
  { name: 'Supplier', model: 'contactSupplier', inputType: 'multiSelect' }
];




